import { makeStyles } from "@material-ui/core/styles";

export const useOrgaoSelectorStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(2),
    padding: theme.spacing(1, 2),
    textTransform: "none",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
  },
}));

